var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1131"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 144",
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1948 37C20.8302 36.9993 20.4721 36.9031 20.1556 36.7208C19.443 36.3143 19 35.5252 19 34.6685V17.3316C19 16.4725 19.443 15.6858 20.1556 15.2793C20.4796 15.0918 20.8477 14.9954 21.2213 15.0002C21.595 15.0049 21.9605 15.1106 22.2797 15.3062L36.9979 24.1755C37.3046 24.3691 37.5575 24.638 37.7328 24.9569C37.908 25.2759 38 25.6344 38 25.9989C38 26.3633 37.908 26.7219 37.7328 27.0408C37.5575 27.3597 37.3046 27.6286 36.9979 27.8222L22.2774 36.6939C21.9507 36.8927 21.5765 36.9985 21.1948 37Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.c3fc07d1d69c47875f3bcd05cf39cd67.svg";
export { ForwardRef as ReactComponent };